import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as moment from 'moment';
import { Provider } from 'react-redux';
import 'moment/locale/ru';
import bugsnag from 'bugsnag-js';
import createPlugin from 'bugsnag-react';

import App from './components/App/App';
import ErrorComponent from './components/Error/ErrorComponent';

import { unregister as unregisterServiceWorker } from './registerServiceWorker';

import { configStore } from './reducers/configStore';

import './styles/index.scss';

import './lib/i18next';
import ErrorBoundary from 'react-error-boundary';

const bugsnagKey = process.env.REACT_APP_BUGSNAG_MARKET_KEY;

moment.locale('ru');

function ErrorFallback(error: any) {
    return (
        <ErrorComponent
            message={error.error.message}
        />
    );
}

let rootElements = (
    <ErrorBoundary
        FallbackComponent={ErrorFallback}
    >
        <Provider store={configStore()}>
            <div className='container'>
                <App />
            </div>
        </Provider>
    </ErrorBoundary>
);

if (bugsnagKey) {
    const bugsnagClient = bugsnag(process.env.REACT_APP_BUGSNAG_MARKET_KEY!);
    const ErrorBound = bugsnagClient.use(createPlugin(React));
    rootElements = (
        <ErrorBound>
            <ErrorComponent>
                <Provider store={configStore()}>
                    <div className='container'>
                        <App/>
                    </div>
                </Provider>
            </ErrorComponent>
        </ErrorBound>
    );
}
ReactDOM.render(rootElements, document.getElementById('root') as HTMLElement);

unregisterServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx